<template>
  <div>
    <div class="md-layout" v-if="false">
      <md-button class="md-dense md-primary" v-on:click="botao_voltar" v-if="botao_voltar_visible">
        <md-icon>arrow_back</md-icon>Voltar para lista
      </md-button>
    </div>
    <div class="md-layout" v-if="show_message == 'on' ">
      <div class="alert alert-success">{{message_text}}</div>
    </div>

    <div class="md-layout" v-if="loading">
      <div class="md-layout-item md-size-100">
        <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
        {{msg_status}} ..
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">Dados Básicos</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Nome</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input name="nome" type="text" placeholder="Nome" v-model="form.nome"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('nome') }}</span>
              </div>

              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">CPF</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="cpf"
                    type="text"
                    placeholder="CPF"
                    v-mask="'###.###.###-##'"
                    v-model="form.cpf"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('cpf') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">RG</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input name="rg" type="text" placeholder="RG" v-model="form.rg"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('rg') }}</span>
              </div>

              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Função</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-select v-model="form.id_funcao" name="id_funcao" id="id_funcao">
                    <md-option
                      v-for="(item,index) in funcao_list"
                      :key="index"
                      :value="item.id"
                    >{{item.descricao}}</md-option>
                  </md-select>
                </md-field>

                <span class="error_input">{{ getErrors('id_funcao') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Data de Cadastro</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <datepicker
                    format="dd/MM/yyyy"
                    :typeable="true"
                    inputClass="md-input"
                    name="data_validade"
                    v-model="data_cadastro"
                    :language="language_date"
                    calendar-button-icon-content="event"
                    :input="datepicker_inputchanged"
                  ></datepicker>
                </md-field>

                <span class="error_input">{{ getErrors('data_cadastro') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Fone</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="fone"
                    type="text"
                    placeholder="Fone"
                    v-model="form.fone"
                    v-mask="'(##)####-####'"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('fone') }}</span>
              </div>

              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Celular</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="celular"
                    type="text"
                    placeholder="Celular"
                    v-mask="'(##)#####-####'"
                    v-model="form.celular"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('celular') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">CRMV</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input name="crmv" type="text" placeholder="CRMV" v-model="form.crmv"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('crmv') }}</span>
              </div>

              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">E-mail</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input name="email" type="text" placeholder="E-mail" v-model="form.email"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('email') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Site</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input name="site" type="text" placeholder="Site" v-model="form.site"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('site') }}</span>
              </div>

              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Contato</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input name="contato" type="text" placeholder="Contato" v-model="form.contato"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('contato') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Ramo de Atividade</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="ramo_atividade"
                    type="text"
                    placeholder="Ramo de Atividade"
                    v-model="form.ramo_atividade"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('ramo_atividade') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Endereço</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="endereco"
                    type="text"
                    placeholder="Endereço"
                    v-model="form.endereco" maxlength="300"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('endereco') }}</span>
              </div>

              <label class="md-layout-item md-size-10 md-xsmall-size-30 md-form-label">CEP</label>
              <div class="md-layout-item md-size-20 md-xsmall-size-70">
                <md-field>
                  <md-input name="cep" type="text" placeholder="CEP" v-model="form.cep" maxlength="8"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('cep') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Bairro</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input name="bairro" type="text" placeholder="Bairro" v-model="form.bairro" maxlength="300"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('bairro') }}</span>
              </div>
            </div>
            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Cidade</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input name="cidade" type="text" placeholder="Cidade" maxlength="300" v-model="form.cidade"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('cidade') }}</span>
              </div>

              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Estado</label>
              <div class="md-layout-item md-size-20 md-xsmall-size-70">
                <md-field>
                  <md-input name="estado" type="text" placeholder="Estado" maxlength="2" v-model="form.estado"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('estado') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Observações</label>
              <div class="md-layout-item md-size-85 md-xsmall-size-70">
                <md-field>
                  <md-textarea v-model="form.obs" name="obs" id="obs" style="height: 120px"></md-textarea>
                </md-field>

                <span class="error_input">{{ getErrors('obs') }}</span>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-size-100">
        <div class="btn-right">
          <md-button
            class="md-info"
            type="button"
            v-bind:disabled="disableButton"
            v-on:click="salvar()"
          >Salvar</md-button>

          <md-button
            class="md-danger"
            type="button"
            v-bind:disabled="disableButton"
            v-if="form != null && form.id != null && form.id !='' && parseInt(form.id) > 0"
            v-on:click="excluir()"
          >Excluir</md-button>
        </div>
      </div>

      <md-dialog :md-active.sync="showDialogError">
        <md-tabs md-dynamic-height>
          <md-tab md-label="Erros">
            <ul class="list-group" v-if="p_validator.errors != null ">
              <li
                v-for="(item, index) in p_validator.errors"
                class="list-group-item"
                :key="index"
                style="text-align: left"
              >{{item.msg}}</li>
            </ul>
            <center>
              <md-button class="md-danger" type="button" @click="hideModal">OK</md-button>
            </center>
          </md-tab>
        </md-tabs>
      </md-dialog>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/validate.css";
@import "../../../assets/css/form_custom.css";
</style>
<script>
import service from "../../../services/NutricionistaService";
import serviceCadBasico from "../../../services/CadastroBasicoService";
import autocomplete from "../../../components/Rend/autocomplete";
import filelogo from "../../../components/Rend/filelogo";
import mixin_validator from "../../../library/mixin/validator";
import mixin_util from "../../../library/mixin/util";
import modal from "../../../components/Modal";
import Util from "../../../library/Util";

import Datepicker from "../../../components/Rend/vuejs-datepicker/src/components/Datepicker";
import ptBR from "../../../components/Rend/vuejs-datepicker/src/locale/translations/pt-BR";

import CardCadastro from "../../../components/CardCadastro";
import vue_select from "../../../components/Rend/vue-select/src/Select.vue";

export default {
  components: {
    autocomplete,
    filelogo,
    modal,
    Datepicker,
    CardCadastro,
    vue_select
  },

  mixins: [mixin_util, mixin_validator],
  props: ["id_load", "show_back_button", "onBack", "onSave"],
  data() {
    return {
      acao: "Cadastrar",
      form: {},
      perfis: [],
      clientes: [],
      clientes_list: [],

      show_perfil: false,
      file_upload: null,

      botao_voltar_visible: true,

      loading: true,

      result2: "",
      disableButton: false,

      show_message: "off",
      message_text: "",
      message_type: "success",
      interval_message: null,
      showDialogError: false,

      msg_status: "Carregando",

      show_modal_contacts: false,
      show_sub_form: true,
      data_cadastro: null,

      language_date: ptBR,
      funcao_list: []
    };
  },
  mounted() {
    let self = this;
    this.form = service.getModel();

    this.configureMessages();

    if (this.show_back_button != null && this.show_back_button != undefined) {
      this.botao_voltar_visible = this.show_back_button;
    }

    this.disableButton = true;

    serviceCadBasico
      .getList("", "4", "descricao", "asc")
      .then(function(response) {
        self.funcao_list = response.data;
      });
    if (
      this.id_load != null &&
      this.id_load != undefined &&
      this.id_load != ""
    ) {
      service.getById(this.id_load).then(function(response) {
        if (response.data.data != null && response.data.data != undefined) {
          self.form = response.data.data;
        } else {
          self.form = response.data.item;
        }
        if (self.form.data_cadastro != null) {
          var intData = self.getApiDateInt(self.form.data_cadastro);

          self.data_cadastro = new Date(intData);
        }
        self.loading = false;
        self.disableButton = false;
      });
    } else {
      this.loading = false;
      this.disableButton = false;
    }

    this.$store.dispatch("setButtonBack", {
      in_form: true,
      rota: "nutricionista",
      exibe: this.show_back_button,
      onBack: this.onBack
    });
    //this.$store.dispatch("user/save", this.tmpUser)
  },
  methods: {
    botao_voltar() {
      var self = this;

      if (this.onBack != null && this.onBack != undefined) {
        this.onBack(self);
      }
    },
    changed(prop) {},

    configureMessages() {
      const dict = {
        // email: {
        //   required: 'O e-mail não pode ser vazio!',
        //   email: 'É necessário informar um e-mail válido!'
        // },
        nome: {
          required: "Nome não pode ser vazio!"
        }
        // cnpj: {
        //   required: 'CPF/CNPJ não pode ser vazio!',
        // cpf: true //testará o método de CPF
        // }
      };

      this.setFieldsValidator(dict);

      //this.p_validator.localize('en', dict);
    },
    onPreSaveContatos() {
      this.show_sub_form = false;
    },
    onPosSaveContatos(itens) {
      this.show_sub_form = true;
    },
    salvar() {
      var self = this;

      if (!this.validar()) return false;

      self.msg_status = "Salvando..";
      self.loading = true;
      self.data_cadastro = Util.dateToBd(self.data_cadastro);

      service
        .salvar(this.form)
        .then(function(response) {
          var retorno = response.data;

          self.show_message = "on";
          self.message_text = "Nutricionista salvo com sucesso!";

          self.interval_message = setInterval(self.clear_message, 6000);

          var item = retorno.item;

          self.msg_status = "Carregando..";
          self.loading = false;

          self.form = item;

          if (self.onSave != null && self.onSave != undefined) {
            self.onSave(retorno, "save");
          }
        })
        .catch(function(error) {});
    },

    excluir() {
      let self = this;
      self.msg_status = "Excluindo..";
      self.loading = true;

      var fn_return = function(response) {
        var retorno = response.data;
        if (self.onSave != null && self.onSave != undefined) {
          self.onSave(retorno, "delete");
        }
        self.msg_status = "Carregando..";
        self.loading = false;
        self.botao_voltar();
      };
      if (this.form.id == null) return false;

      service.delete(this.form.id).then(fn_return);
      //	obj_api.call_delete("cliente", this.id, fn_return);
    },
    clear_message() {
      this.show_message = "off";
      clearInterval(this.interval_message);
    },
    hideModal() {
      this.showDialogError = false;
    },
    datepicker_inputchanged(ev) {},
    validar() {
      this.indicateAllErrors(); //Verifica todos os possíveis erros em tela.
      console.log("erros? ");
      console.log(this.p_validator.errors);

      if (this.p_validator.errors.length > 0) {
        this.showDialogError = true;
        return false;
      }

      return true;
    }
  }
};
</script>